<template>
  <div style="height: 100vh;width: 100vw;">
    <!-- 页头 -->
    <nav-header2 style="position: absolute;z-index: 999;"></nav-header2>
    <div style="height: 60px;"></div>
    <div style="display: flex;height: calc(100% - 60px);width: 100%;">
      <!-- 侧边栏 -->
      <side-bar></side-bar>
      <div style="flex: 1;padding: 10px;background-color: #e4e7ed;display: flex;">
        <div class="content-box">
          <div class="table-list">
            <div class="title-box">
              <!-- 标题 -->
              <div class="title">公告设置</div>
              <!-- 按钮 -->
            </div>
            <div class="notice-content">

              <system-setting-item v-for="(item, index) in noticeList" :key="index" set="theme" :etitle="item.etitle"
                :slots="item.slots" :title="item.title" :content="item.content" :inputc.sync="item.inputc"
                @handleSetContent="handleSetNotice(item)">
                <template v-slot:image>
                  <div class="uploadfile flex">
                    <el-upload class="upload-demo" action="#" :auto-upload="false" :show-file-list="false"
                      :on-change="($event) => handleChange($event, item)">
                      <el-button>上传图片</el-button>
                    </el-upload>
                    <el-tooltip class="item" effect="dark" :content="item.filename" placement="top">
                      <p class="ellipsis">{{ item.filename }}</p>
                    </el-tooltip>
                    <div class="preview-container" v-if="item.inputc">
                      <img :src="item.inputc" :alt="item.title + '预览'" title="点击预览图片" class="preview-img"
                        @click="previewImageClick">
                      <i class="el-icon-close" @click="removePreview(item)"></i>
                    </div>
                  </div>
                  <el-progress
                    :style="{ 'display': showprogress == true && selectLogo == item.title ? 'block' : 'none' }"
                    :percentage="percent"></el-progress>
                </template>
                <template v-slot:button>
                  <div class="notice-button">
                    <el-button @click="previewNoticeDialog">公告预览</el-button>
                    <el-button @click="releaseNotice(true)">公告发布</el-button>
                    <el-button @click="releaseNotice(false)">公告关闭</el-button>
                  </div>
                </template>
                <template v-slot:date>
                  <div class="">
                    {{ item.inputc }}
                  </div>
                </template>
              </system-setting-item>
            </div>
          </div>
        </div>
      </div>
    </div>

    <preview-image-dialog ref="previewImageDialog" :preview-image="previewImage"
      :filename="filename"></preview-image-dialog>

    <!--    预览公告弹框-->
    <notice-preview-dialog ref="noticePreviewDialog" :image-url="previewImage"
      :link="noticeList[1].inputc"></notice-preview-dialog>
  </div>
</template>

<script>
import PreviewImageDialog from "@/components/previewImageDialog.vue";
import NoticePreviewDialog from "@/components/NoticePreviewDialog.vue";

export default {
  name: "Notice",
  components: { NoticePreviewDialog, PreviewImageDialog },
  data() {
    return {
      showLargePreview: false, // 大图预览显示控制
      showprogress: false,
      selectLogo: '',
      percent: 0,
      progress: 0,
      filename: '',
      previewImage: '', // 预览图片的base64数据
      noticeList: [
        {
          title: '公告图片',
          etitle: 'image',
          inputc: null,
          slots: "image",
          content: '云平台公告更新弹框图片',
          filename: '',
        },
        {
          title: '公告链接',
          etitle: 'link',
          inputc: null,
          content: '云平台公告更新弹框图片跳转的链接'
        },
        {
          title: '更新时间',
          etitle: 'date',
          inputc: null,
          content: '云平台公告更新时间',
          slots: 'date',
        },
        {
          title: '公告操作',
          etitle: 'button',
          inputc: null,
          content: '云平台公告更新弹框进行预览、发布、关闭操作',
          slots: 'button',
        },
      ]
    }
  },
  methods: {
    // 上传图片
    handleChange(file, item) {
      item.showprogress = true
      this.selectLogo = item.type;
      console.log(file, item.type, "datalllllll");
      const imgFile = file.raw;
      const isLt5M = file.size / 1024 / 1024 < 5;

      if (imgFile.type !== "image/png" && imgFile.type !== "image/jpeg") {
        this.$message({
          message: "只支持上传png或者jpg格式文件",
          type: 'error'
        });
        item.showprogress = false
        return
      } else if (!isLt5M) {
        this.$message.error('上传图片大小不能超过5MB!');
        item.showprogress = false
        return
      } else if (imgFile.type == "image/png" || imgFile.type == "image/jpeg" || file.name.endsWith('.ico')) {

        this.filename = imgFile.name;
        item.filename = imgFile.name;

        // 读取文件并显示预览
        this.readFileAndPreview(imgFile);

        const interval = setInterval(() => {
          this.percent += Math.floor(Math.random() * 10) + 5
          if (this.percent >= 100) {
            this.percent = 100
            clearInterval(interval)
            setTimeout(() => {
              item.showprogress = false
            }, 500)
          }
        }, 300)
      }
    },

    // 读取文件并预览
    readFileAndPreview(file) {
      const reader = new FileReader();

      reader.onload = (e) => {
        // 将base64数据保存到previewImage中
        this.previewImage = e.target.result;
        // 如果需要，也可以保存到对应的noticeList项中
        const noticeItem = this.noticeList.find(item => item.etitle === 'image');
        if (noticeItem) {
          noticeItem.inputc = e.target.result;
        }
      };

      reader.onerror = (error) => {
        console.error('文件读取失败:', error);
        this.$message.error('文件读取失败');
        this.showprogress = false;
      };

      reader.readAsDataURL(file);
    },

    // 移除图片
    removePreview(item) {
      this.$confirm('确定删除图片？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.previewImage = '';
        this.filename = '';
        item.filename = '';
        this.percent = 0;
        item.inputc = null;
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        });
      });
    },

    // 预览上传图片
    previewImageClick() {
      this.previewImage = this.noticeList[0].inputc;
      this.$refs.previewImageDialog.openDialog();
    },

    // 预览公告图片
    previewNoticeDialog() {
      this.previewImage = this.noticeList[0].inputc;
      if (!this.previewImage) {
        this.$message({
          type: 'warning',
          message: '暂无公告图片'
        });
        return;
      }
      this.$refs.noticePreviewDialog.openDialog();
    },

    // // 下载图片
    // downloadImage() {
    //   if (!this.previewImage) return;
    //
    //   const link = document.createElement('a');
    //   link.href = this.previewImage;
    //   link.download = this.filename || '公告图片';
    //   document.body.appendChild(link);
    //   link.click();
    //   document.body.removeChild(link);
    // },

    // 默认配置提交
    async handleSetNotice(item) {
      let params = {}
      params = {
        // key: item.etitle,
        link: item.inputc
      }
      console.log("item", item);
      if (item.etitle === 'image') {
        // 直接使用已经转换好的base64数据
        if (this.previewImage) {
          params = {
            // key: item.etitle,
            fileData: this.previewImage,
            fileName: item.filename || 'uploaded_image.png'
          }
        }
      }
      // 这里可以调用API上传数据
      // console.log(params, item, this.uploadLogo);
      const res = await this.$apiFun.noticeSettingUpload(params);
      if (res.code == 200) {
        this.$message({
          message: res.msg,
          type: 'success'
        });
        this.getNoticeSetting()
      } else {
        this.$message({
          message: res.msg,
          type: 'error'
        });
      }
    },
    // 发布公告
    async releaseNotice(value) {
      let params = {
        release: value
      }
      const res = await this.$apiFun.releaseNotice(params);
      if (res.code == 200) {
        this.$message({
          message: res.msg,
          type: 'success'
        });
        this.getNoticeSetting()
      } else {
        this.$message({
          message: res.msg,
          type: 'error'
        });
      }
    },

    // 获取公告配置信息
    async getNoticeSetting() {
      let array = process.env.VUE_APP_PIc_URL.split(":");
      console.log("array", array);
      try {
        const res = await this.$apiFun.getNoticeSettingsInfo();
        if (res.data.image) {
          this.noticeList[0].inputc = array[0] + ":" + array[1] + (array.length > 2 ? ":" + array[2] : "") + "/" + res.data.image;
        }
        this.noticeList[1].inputc = res.data.link;
        this.noticeList[2].inputc = res.data.date;
        console.log("noticeList", this.noticeList)
      } catch (error) {
        console.error('更新失败:', error);
      }
    }
  },
  mounted() {
    this.getNoticeSetting();
  }
}
</script>

<style scoped lang="less">
.content-box {
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  padding: 0 16px 16px 16px;
  background-color: white;
  white-space: nowrap;
  width: 0px;
  overflow: auto;
}

.title-box {
  margin: 20px 0px 10px;
  height: 30px;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #ebeef5;
}

.title {
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 10px;
}

.notice-content {
  display: flex;
  flex-direction: column;
  flex: 1;
  font-size: 12px;
  border: 1px solid #ebeef5;
  padding: 16px;

  li {
    display: flex;
    align-items: center;
    justify-content: space-between;

    div {
      white-space: nowrap;
    }

    :deep(.el-input) {
      width: 200px;

      .el-input__inner {
        font-size: 12px;
      }
    }

    :deep(.el-select) {
      font-size: 12px;
      width: 200px;

      .el-select-dropdown__empty {
        font-size: 12px;
      }
    }

    &:last-child {
      justify-content: end;

      .el-button {
        font-size: 12px;
        border: none;
        background-color: #1677ff;
      }
    }
  }

  :deep(.el-upload) {
    .el-button {
      border: none;
      font-size: 12px;
      padding: 0;
      color: #1677ff;

      &:hover {
        background-color: transparent;
        color: #1677ff;
      }

      &:focus {
        background-color: transparent;
        color: #1677ff;
      }
    }
  }

  .notice-button {
    display: flex;

    .el-button {
      font-size: 10px;
    }
  }

  .uploadfile {
    align-items: center;

    p {
      margin: 0 !important;
      margin-left: 8px !important;
      cursor: pointer;
    }

    .preview-container {
      display: flex;
      justify-content: space-between;
      margin-left: 20px;
      position: relative;

      .preview-img {
        max-width: 100px;
        max-height: 36px;
      }

      .el-icon-close {
        position: absolute;
        top: 0;
        right: 0;
        color: #fff;
      }
    }
  }
}

/* 大图预览样式 */
:deep(.el-dialog__body) {
  padding: 20px;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .preview-area .image-preview .preview-img {
    max-width: 150px;
    max-height: 100px;
  }
}
</style>